/**
 * The LpSeaProductHero component
 * Examples: https://www.meinfoto.de/angebot
 * Hero with CTA Button
 * CMS Blocks for Trust
 * Products / Product Examples
 * Perks
 */
import React from "react";
import PropTypes from "prop-types";
import { Container, Col, Row } from "reactstrap";
import ResponsivePicture from "../../ResponsivePicture";
import { Link } from "react-router-dom";
import Perks from "../../../components/Perks";
import CMSBlock from "../../../components/CMSBlock";
import filter from "lodash/filter";
// FIXME enforce CMSBlockTeaser Layout
import CMSBlockTeaser from "../../../components/CMSBlock/utils/CMSBlockTeaser";
const _ = {
  filter: filter,
};
/**
 * Stateless react component to render the LpSeaProductHero component
 * @param {Object} props the props passed to the page.
 */
const LpSeaProductHero = (props, context) => {
  const { landingpage, productTeasers, cmsBlock1, cmsBlock2, cmsBlock3 } =
    props;
  const productBlocks = _.filter(productTeasers, function (cmsBlock) {
    return (
      cmsBlock.slug.startsWith("overview_product_") ||
      cmsBlock.slug.startsWith("product_") ||
      cmsBlock.slug.startsWith("home_teaser_") ||
      cmsBlock.slug.startsWith("home_product_")
    );
  });

  const contentBlocks = _.filter(productTeasers, function (cmsBlock) {
    return (
      !cmsBlock.slug.startsWith("overview_product_") &&
      !cmsBlock.slug.startsWith("product_") &&
      !cmsBlock.slug.startsWith("home_teaser_") &&
      !cmsBlock.slug.startsWith("home_product_")
    );
  });
  return (
    <div className="lp-product-hero">
      <div className="hero container">
        <div className="hero__bg">
          <ResponsivePicture
            mediumData={{
              sources: landingpage.hero_image,
              metadata: {
                width: "100%",
                height: "100%",
              },
            }}
            altTitle={landingpage.title}
            cover
          />
        </div>
        <header className="hero__content-floating col-lg-5 col-md-12 bg-white mx-5 my-4 p-3 pull-right rounded shadow">
          {landingpage.title && <h1>{landingpage.title}</h1>}
          {landingpage.intro && (
            <div dangerouslySetInnerHTML={{ __html: landingpage.intro }} />
          )}
          {landingpage.cta_title &&
            landingpage.cta_link &&
            (landingpage.cta_link.substr(0, 4) === "http" ||
              landingpage.cta_link.substr(0, 1) === "#") && (
              <a
                href={`${landingpage.cta_link}`}
                className="btn btn-primary btn-lg btn-block"
              >
                {landingpage.cta_title}
              </a>
            )}

          {landingpage.cta_title &&
            landingpage.cta_link &&
            landingpage.cta_link.substr(0, 4) !== "http" &&
            landingpage.cta_link.substr(0, 1) !== "#" && (
              <Link
                to={`/${landingpage.language}/${landingpage.cta_link}`}
                className="btn btn-primary btn-lg btn-block"
              >
                {landingpage.cta_title}
              </Link>
            )}
        </header>
      </div>
      <Container className="bg-light py-2" style={{ clear: "both" }}>
        <Row
          className="justify-content-md-center px-4"
          id="highlight-products-jumpmark"
        >
          {cmsBlock1 && cmsBlock1[0] && (
            <Col xl={4} md={12}>
              <CMSBlock cmsBlock={cmsBlock1[0]} />
            </Col>
          )}
          {cmsBlock2 && cmsBlock2[0] && (
            <Col xl={4} md={12}>
              <CMSBlock cmsBlock={cmsBlock2[0]} />
            </Col>
          )}
          {cmsBlock3 && cmsBlock3[0] && (
            <Col xl={4} md={12}>
              <CMSBlock cmsBlock={cmsBlock3[0]} />
            </Col>
          )}
        </Row>
      </Container>
      <Container className="my-5">
        {landingpage.subtitle && <h2>{landingpage.subtitle}</h2>}
        <Row>
          {productBlocks?.map((block) => (
            <Col xl={3} md={6} key={block.id}>
              <CMSBlockTeaser
                key={`home_cms_block_${block.id}`}
                cmsBlock={block}
              />
            </Col>
          ))}
        </Row>
      </Container>
      {landingpage.content && (
        <Container className="my-5">
          <div dangerouslySetInnerHTML={{ __html: landingpage.content }} />
        </Container>
      )}
      <Perks />
      {contentBlocks?.map((cmsBlock, idx) => {
        return (
          <>
            <Container
              key={"cmsblock-" + idx}
              className={"my-5 py-3" + (idx % 3 ? "" : " bg-light")}
            >
              <CMSBlock cmsBlock={cmsBlock} invert={idx % 2} />
            </Container>
          </>
        );
      })}
    </div>
  );
};

/** define proptypes for the form */
LpSeaProductHero.propTypes = {
  /** the item */
  landingpage: PropTypes.object.isRequired,
  productTeasers: PropTypes.array,
  cmsBlock1: PropTypes.array,
  cmsBlock2: PropTypes.array,
  cmsBlock3: PropTypes.array,
};

/**  define proptype for the 'translation' function  */
LpSeaProductHero.contextTypes = {
  t: PropTypes.func,
};
export default LpSeaProductHero;
